import { render, staticRenderFns } from "./documentUploader.vue?vue&type=template&id=2a4a203d"
import script from "./documentUploader.vue?vue&type=script&lang=js"
export * from "./documentUploader.vue?vue&type=script&lang=js"
import style0 from "./documentUploader.vue?vue&type=style&index=0&id=2a4a203d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports